<template>
  <div class="ourStory">
    <div class="timeline-wrapper">
      <v-timeline :dense="$vuetify.breakpoint.smAndDown">
        <v-timeline-item
          v-for="(event, e) in timeline"
          :key="e"
          color="#f82020"
          small
        >
          <template v-slot:opposite>
            <span class="headline when" v-text="event.when" />
          </template>
          <v-card class="elevation-2 colored-background-on-hover event-story">
            <v-card-title v-if="$vuetify.breakpoint.smAndDown">
              {{ event.when }}
            </v-card-title>
            <v-card-text>
              {{ event.text }}
              <v-carousel
                v-if="event.images"
                cycle
                height="270"
                hide-delimiter-background
                show-arrows-on-hover
              >
                <v-carousel-item v-for="(image, i) in event.images" :key="i">
                  <v-img
                    :src="image"
                    max-width="100%"
                    max-height="300px"
                    contain
                  />
                </v-carousel-item>
              </v-carousel>
            </v-card-text>
          </v-card>
        </v-timeline-item>
      </v-timeline>
    </div>
  </div>
</template>
<style scoped>
.ourStory {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
  width: 100%;
}

.timeline-wrapper {
  /* IE11 fix */
  max-width: 1000px;
  width: 100%;
}

.when {
  background: #f82020;
  padding: 8px;
  border-radius: 4px;
}

.colored-background-on-hover:hover {
  background: rgba(248, 32, 32, 0.8);
}

.colored-background-on-hover {
  transition: background 2s;
}
</style>

<script>
export default {
  name: "ourStory",
  data: () => ({
    timeline: [
      {
        text: "52 Mitglieder gründen den SV Westerheim 1930 e.V.",
        when: "11. Mai 1930",
        images: [
          "images/1930-SVW-Mannschaft.jpg",
          "images/1931-SVW-Mannschaft.jpg"
        ]
      },
      {
        text: "Mitglieder bauen eine kleine Sprungschanze",
        when: "1947"
      },
      {
        text: "Am jetzigen Hallenbadparkplatz wird eine Sporthütte gebaut.",
        when: "1951 - 1954"
      },
      {
        text: "1. Jugendmannschaft - Fußball - wird aktiv.",
        when: "1952"
      },
      {
        text: "Planung, Bau, Einweihung Sportheim",
        when: "1963 - 1967"
      },
      {
        text:
          "Am Sportplatz vor dem Sportheim wird eine Flutlichtanlage installiert.",
        when: "1966"
      },
      {
        text:
          "Gründung der Tischtennisabteilung.\nSpielort: Gymnastikraum Schule",
        when: "1969"
      },
      {
        text: "Bau neuer Sportplatz (jetziges Hauptspielfeld)",
        when: "1971 - 1974"
      },
      {
        text:
          "Die erste Bande zum Sportverein in Westerheim/Allgäu wird durch die AH geknüpft.",
        when: "1974"
      },
      {
        text:
          "Mit der Fertigstellung des Hallenbades wurde die Schwimmabteilung gegründet.",
        when: "1975"
      },
      {
        text: "Gründung der Turnabteilung.\nTurnraum: Gymnastikraum Schule",
        when: "1976"
      },
      {
        text: "Umbau Sportplatz vor dem Sportheim",
        when: "1979"
      },
      {
        text: "Einweihung Sportplatz",
        when: "1981"
      },
      {
        text: "Mannschaft steigt in die Bezirksliga auf",
        when: "1981"
      },
      {
        text:
          "Mit Fertigstellung der Alb Halle: Gründung der Volleyballabteilung und Ausbau der Turnabteilung",
        when: "1984"
      },
      {
        text: "Umbau und Erweiterungsbau des Sportheims",
        when: "1983 - 1984"
      },
      {
        text: "Wiederbelebung der Skiabteilung",
        when: "1986"
      },
      {
        text: "Ballfangzäune werden gebaut",
        when: "1990"
      },
      {
        text: "1. Mannschaft spielt in der Landesliga",
        when: "1992"
      },
      {
        text: "Renovierung Sportheim Sanierung WC Anlagen",
        when: "1997"
      },
      {
        text:
          "Erneuerung Flutlichtanlage und Ausbau Dachgeschoss des Sportheimes",
        when: "1999"
      },
      {
        text:
          "Der Bundesligist, VFB Stuttgart, ist mit acht Nationalspieler und Trainer Felix Magath zu Gast beim SVW.",
        when: "2002"
      },
      {
        text: "Fertigstellung Garagenanbau",
        when: "2008"
      },
      {
        text: "Einweihung Neubau für Umkleidekabinen",
        when: "2012"
      },
      {
        text:
          "Neugestaltung Zufahrt an der Nordseite des Sportgeländes Umbau Sportheim",
        when: "2014"
      },
      {
        text: "Anschaffung Team Bus",
        when: "2017"
      },
      {
        text: "Sanierung Hauptspielfeld Fußball",
        when: "2018"
      },
      {
        text:
          'Sprecherkabine wird gebaut. Das Sportheim erhält die Bestuhlung von der Gaststätte "Alb Halle".',
        when: "2019"
      },
      {
        text: "1204 Mitglieder",
        when: "11. Mai 2020"
      }
    ]
  })
};
</script>
